<template>
    <div v-if="showModal">
        <form ref="forma">
            <b-modal
                    v-model="showModalLocal"
                    :title="'Создать задачу'"
                    class="modal-primary"
                    size="md"
                    ok-variant="primary"
                    @hide.prevent
                    @ok="handleOk"
                    @cancel="handleCancel"
                    @close="handleCancel"
                    ref="my-modal"
            >

                <div class="row">
                    <div class="col col-md-6">
                        <b-form-group
                                label="Выберите время начала"
                                description=''
                                :state="validateState('task_wakeup')"
                                :invalid-feedback="veeErrors.first('task_wakeup')">

                            <b-form-select
                                    :options="opts"
                                    :plain="true"
                                    value-field="id"
                                    text-field="title"
                                    v-model="task.wakeup"
                                    v-validate="{required:true}"
                                    data-vv-as="'Время начала'"
                                    name="task_wakeup"
                                    class="form-control"
                            >
                            </b-form-select>
                        </b-form-group>
                    </div>
                    <div class="col col-md-6">
                        <b-form-group v-if="task.wakeup==='at'" label="укажите время">
                            <date-picker v-model="task.wakeup_at" :config="config"></date-picker>
                        </b-form-group>
                    </div>
                </div>

                <b-form-group label="Заголовок">
                    <input class="form-control" v-model="task.subject">
                </b-form-group>

                <b-form-group label="Подробное описание">
                    <textarea class="form-control" v-model="task.info"></textarea>
                </b-form-group>

                <template slot="modal-footer" slot-scope="{ ok, cancel, close }">
                    <b-button size="sm" variant="outline-secondary" @click="cancel()">
                        Закрыть
                    </b-button>

                    <b-button size="sm" variant="outline-success" @click="task.type=1;ok()">
                        <i class="icon-pin"></i>&nbsp;
                        Напоминание
                    </b-button>

                    <b-button size="sm" variant="outline-success" @click="task.type=1;ok()">
                        <i class="icon-phone"></i>&nbsp;
                        Позвонить
                    </b-button>

                    <b-button size="sm" variant="outline-success" @click="task.type=2;ok()">
                        <i class="icon-envelope"></i>&nbsp;
                        Написать
                    </b-button>
                </template>
            </b-modal>
        </form>
    </div>
</template>


<script>
    import datePicker from 'vue-bootstrap-datetimepicker';
    import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
    import { functions } from '@/functions.js';
    import { functions_loaders } from '@/functions_loaders.js';
    import { functions_tasks } from '@/functions_tasks.js';

    export default {
        name: 'CreateReminderDialog',
        mixins: [functions,functions_loaders,functions_tasks],
        components: { datePicker },
        data: function () {
            return {
                task:{
                    wakeup:null,
                    wakeup_at:null,
                    type:null,
                    subject:null,
                    info:null,
                    voucher_id: null,
                    customer_id: null,
                    order_id: null,
                },
                config:{
                    format: 'DD.MM.YYYY HH:mm',
                    locale: 'ru',
                    stepping:30
                },
                opts: [
                    {id:null,title:'когда выполнить'},
                    {id:'at',title:'указать точное время'},
                    {id:'0m',title:'Прямо сейчас'},
                    {id:'5m',title:'Через 5 минут'},
                    {id:'15m',title:'Через 15 минут'},
                    {id:'30m',title:'Через пол часа'},
                    {id:'1h',title:'Через час'},
                    {id:'2h',title:'Через 2 часа'},
                    {id:'4h',title:'Через 4 часа'},
                    {id:'1d',title:'Завтра'},
                    {id:'2d',title:'Послезавтра'},
                    {id:'3d',title:'Через 2 дня'},
                    {id:'7d',title:'Через неделю'},
                    {id:'14d',title:'Через 2 недели'},
                ]
            };
        },
        model: {
            prop: "showModal",
            event: "hide"
        },
        props: {
            showModal: [Number, Boolean],
            voucher_id: Number,
            customer_id: Number,
            order_id: Number,
        },
        watch: {
        },
        methods: {
            handleCancel: function () {
                this.$emit("hide", false);
            },
            handleOk: function () {
                this.$validator.validateAll().then((result) => {
                    if (!result) {
                        return
                    }
                    this.task.voucher_id = this.voucher_id;
                    this.task.customer_id = this.customer_id;
                    this.task.order_id = this.order_id;
                    this.startTask(this.task);
                    this.$emit("hide", false);
                });

            },
            handleSubmit: function () {
                return this.handleOk();
            },

            handleCloseOk:function(evt) {
                if (!this.$refs.form.checkValidity()) {
                    return;
                }
                this.closeTask();
            },

        },
        computed: {
            showModalLocal: {
                get: function () {
                    return this.showModal
                },
                set: function (newValue) {}
            }
        },
        created: function() {
            //console.log('SimpleDialog: created');
        },
        mounted: function() {
            //console.log('SimpleDialog: mounted');
        },
        updated: function() {
            //console.log('SimpleDialog: updated');
        },
    }
</script>
